import PortfoliosTable from "./PortfoliosTableContainer";

export default PortfoliosTable;
